export default __webpack_public_path__ + "static/media/sui-disable.5a526be8.png";